import React, { Component } from "react";
import { Col, Form, Row } from "antd";
import PropTypes from "prop-types";
import { withApollo } from "react-apollo";

import InDocumentInformation from "./includes/InDocumentInformation";
import InPersonnelInformation from "./includes/InPersonnelInformation";
import InWelfareReimbursementInformation from "./includes/InWelfareReimbursementInformation";

class SecWelfareReimbursementInformation extends Component {
  render() {
    const { rawData } = this.props;

    return (
      <Row
        gutter={16}
        type="flex"
        justify="start"
        align="top"
        className="py-2 mb-4"
      >
        <Col md={24} className="mb-3">
          <InDocumentInformation rawData={rawData} />
          <hr className="my-4" />
        </Col>
        <Col md={24} className="mb-3">
          <InPersonnelInformation rawData={rawData} />
          <hr className="my-4" />
        </Col>
        <Col md={24} className="mb-3">
          <InWelfareReimbursementInformation rawData={rawData} />
        </Col>
      </Row>
    );
  }
}

SecWelfareReimbursementInformation.defaultProps = {
  autoFocus: false,
};

SecWelfareReimbursementInformation.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedSecWelfareReimbursementInformation = Form.create()(
  SecWelfareReimbursementInformation
);

export default withApollo(WrappedSecWelfareReimbursementInformation);
